import React from 'react'
import { $neutralGray100 } from '../../styles/colors/primitives'

function DownloadFileIcon() {
  return (
    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M11 6L10.3 5.3L6.5 9.1V0H5.5V9.1L1.7 5.3L1 6L6 11L11 6ZM11 11V13H1V11H0V13C0 13.6 0.4 14 1 14H11C11.6 14 12 13.6 12 13V11H11Z" fill={$neutralGray100}/>
    </svg>
  )
}

export default DownloadFileIcon

